/**
 * MODULE: _shared/frontend-shell/src/pages/dashboard/legacyOpportunitiesRedirect.ts
 * PURPOSE: Map legacy /opportunities query params to /crm/deals CRM filter keys
 * PUBLIC_API: mapLegacyOpportunitiesSearchToCrmDeals
 * AGENT_SAFETY: SAFE
 * RECENT: 2026-06-04 [2.2.1272] — Pass through singular stage, owner, and dealId query keys for CRM deals hub filters.
 */

/** Convert dashboard pipeline / legacy opportunity URL facets into CRM deals hub query params. */
export function mapLegacyOpportunitiesSearchToCrmDeals(
  legacy: URLSearchParams
): URLSearchParams {
  const next = new URLSearchParams();
  const q = legacy.get('q')?.trim();
  if (q) next.set('q', q);

  const stages = legacy.get('stages')?.trim();
  if (stages) {
    next.set('stages', stages);
    const first = stages.split(',')[0]?.trim();
    if (first) next.set('stage', first);
  }

  const owners = legacy.get('owners')?.trim();
  if (owners) {
    next.set('owners', owners);
    const first = owners.split(',')[0]?.trim();
    if (first) next.set('owner', first);
  }

  const region = legacy.get('region')?.trim();
  if (region) next.set('territory', region);

  const stage = legacy.get('stage')?.trim();
  if (stage && !next.has('stage')) next.set('stage', stage);

  const owner = legacy.get('owner')?.trim();
  if (owner && !next.has('owner')) next.set('owner', owner);

  const dealId = legacy.get('dealId')?.trim();
  if (dealId) next.set('dealId', dealId);

  for (const key of ['from', 'period', 'start', 'end', 'segment'] as const) {
    const v = legacy.get(key)?.trim();
    if (v) next.set(key, v);
  }

  return next;
}
